import React from "react";
import styled from "styled-components";
import Admin from "../Admin/Admin";

const Main = styled.div`
  padding-top: 52px;
  margin-bottom: 52px;
`;

export default function AdminView() {
  return (
    <Main>
      <Admin />
    </Main>
  );
}
